Ext.define('SA.VectorMapCoordinate', {
    statics: {
        fromLngLat([lng, lat]) {
            return SA.VectorMapCoordinate.fromXY(turf.toMercator([lng, lat]));
        },

        fromXY([x, y]) {
            return new SA.VectorMapCoordinate(x, y);
        }
    },

    constructor(x, y) {
        this.x = x;
        this.y = y;
    },

    equals(other) {
        return SA.Json.equal(this.toXY(), other?.toXY());
    },

    getX() {
        return this.x;
    },

    getY() {
        return this.y;
    },

    metersTo(other) {
        return turf.distance(this.toLngLat(), other.toLngLat()) * 1000;
    },

    toLngLat() {
        return turf.toWgs84(this.toXY());
    },

    toXY() {
        return [this.getX(), this.getY()];
    }
});